import { useEffect, useState } from "react";
import { StudentSurveyDialog } from "./StudentSurveyDialog";
import { fetchStudentSurveyStatus, fetchSurvey, skipSubmitSurvey, submitSurvey } from "../../lib/surveys";

/**
 * Moment one: the pop-up right after a student submits their campaign for
 * review. `trigger` flips truthy on each successful submission; the survey
 * opens once, and a skip is remembered server-side so it never nags.
 */
export const PostSubmitSurvey = ({ trigger }) => {
  const [survey, setSurvey] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!trigger) return undefined;
    let cancelled = false;
    Promise.all([fetchStudentSurveyStatus(), fetchSurvey("student_submit")])
      .then(([st, sv]) => {
        const s = st.submit;
        if (cancelled || !s.enabled || s.completed || s.skipped_at || !sv.questions?.length) return;
        setSurvey(sv);
        setTimeout(() => !cancelled && setOpen(true), 900);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [trigger]);

  if (!survey) return null;
  return (
    <StudentSurveyDialog
      survey={survey}
      open={open}
      testid="post-submit-survey"
      eyebrow="Optional, under a minute"
      skipLabel="Skip for now"
      submitLabel="Send my answers"
      onSkip={async (done) => { setOpen(false); if (!done) await skipSubmitSurvey().catch(() => {}); }}
      onSubmit={async (answers) => (await submitSurvey("student_submit", { touchpoint: "post_submit", answers })).thanks}
    />
  );
};
